//#region module
//import { Icon } from '@iconify/react'
//import FunnelOutline from '@iconify/icons-eva/funnel-outline'
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent  as VisualizeIcon } from "../../assets/icons/icon-visualize.svg"
import { ReactComponent  as FilterIcon } from "../../assets/icons/icon-filter.svg"
//#endregion

//const getIcon = (name) => <Icon icon={name} width={100} height={100} />
const getIcon = (name) => <SvgIcon component={name} width={100} height={100} />

const reportDashboardSidebarConfig = [
  {
    title: 'Visualize',
    path: '#',
    icon: getIcon(VisualizeIcon),
  },
  {
    title: 'Filter',
    path: '#',
    icon: getIcon(FilterIcon),
  }
]

export default reportDashboardSidebarConfig
